import { type TablePaginationConfig } from 'antd'

import { formatNumber } from './formatting'

export type PaginationSize = 'xs' | 'sm' | 'default'

const PAGE_SIZE_OPTIONS = ['5', '10', '25', '50']

interface ResponsiveTablePaginationOptions {
    name?: string
    paginationSize?: PaginationSize
}

export const getResponsiveTablePaginationOptions = (
    config: ResponsiveTablePaginationOptions
): TablePaginationConfig => {
    const { name = 'Rows', paginationSize = 'default' } = config

    return {
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
        showTotal: (total, range) => {
            const prefix = `${formatNumber(range[0])} - ${formatNumber(
                range[1]
            )} of `
            const suffix = `${formatNumber(total)} Total ${name}`
            return (paginationSize === 'default' ? prefix : '') + suffix
        },
        position: ['bottomRight'],
        size: 'small',
    }
}
